module.exports = __webpack_public_path__ + "img/light-mud-decal-00.696e0863.png";